import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal, SectionShell } from "./Shared";

const SERVICES = [
  {
    num: "01",
    title: "Representation",
    desc: "Contract guidance, opportunity management, negotiation support and professional career planning.",
  },
  {
    num: "02",
    title: "Brand Development",
    desc: "Athlete positioning, identity, social strategy, content development and audience growth.",
  },
  {
    num: "03",
    title: "Partnerships",
    desc: "Sponsorships, endorsements, event partnerships, travel opportunities and co-branded products.",
  },
  {
    num: "04",
    title: "Career Growth",
    desc: "Media opportunities, public appearances, business development and long-term planning beyond competition.",
  },
];

export default function Services() {
  return (
    <SectionShell id="services" className="bg-surface/40">
      <Reveal>
        <Eyebrow className="mb-5">— 03 / Services</Eyebrow>
        <h2 className="max-w-3xl font-display text-4xl uppercase leading-[1.05] sm:text-5xl lg:text-6xl">
          Four capabilities. <span className="text-volt">One coordinated sports management system.</span>
        </h2>
      </Reveal>

      <div className="mt-14">
        {SERVICES.map((s, i) => (
          <Reveal key={s.num} delay={0.05 * i}>
            <div
              className={`group grid items-center gap-4 border-t border-white/10 px-2 py-10 transition-colors duration-300 hover:bg-ink/60 md:grid-cols-12 md:gap-8 ${
                i === SERVICES.length - 1 ? "border-b" : ""
              }`}
              data-testid={`service-row-${s.num}`}
            >
              <span className="font-mono text-sm text-volt md:col-span-1">
                /{s.num}
              </span>
              <h3 className="font-display text-3xl uppercase text-white transition-all duration-300 group-hover:translate-x-2 group-hover:text-volt sm:text-4xl md:col-span-5">
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed text-slate-400 md:col-span-5">
                {s.desc}
              </p>
              <span className="hidden justify-end md:col-span-1 md:flex">
                <ArrowUpRight className="h-6 w-6 text-slate-600 opacity-0 transition-all duration-300 group-hover:text-volt group-hover:opacity-100" />
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </SectionShell>
  );
}
